"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = exports.IconVariants = exports.IconSizes = void 0;
var _iconNames = _interopRequireDefault(require("./iconNames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Icons = _iconNames.default;
exports.Icons = Icons;
var IconSizes = {
  Micro: 'micro',
  Tiny: 'tiny',
  Small: 'small',
  Normal: 'normal',
  Big: 'big',
  Huge: 'huge'
};
exports.IconSizes = IconSizes;
var IconVariants = {
  Mini: 'mini',
  Outline: 'outline',
  Solid: 'solid'
};
exports.IconVariants = IconVariants;